module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('swiper', {
    staticClass: "swiper-wrapper",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_vm._l((_vm.images), function(pic, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": pic,
        "alt": "Image Description"
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "level3-gallery-prev swiper-button-prev",
    attrs: {
      "slot": "button-prev",
      "id": "prev-image"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "level3-gallery-next swiper-button-next",
    attrs: {
      "slot": "button-next",
      "id": "next-image"
    },
    slot: "button-next"
  })], 2)], 1)])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a8808438", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8808438"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/frameResources/frameComponents/FrameModal.vue
// module id = 559
// module chunks = 4